import axios from 'axios'

const state = {
	list: [],
};

const mutations = {
	SET_LIST: (state, list) => {
		state.list = list;
	},
}

const options = {
	headers: {
		'Accept': 'application/vnd.api+json',
		'Content-Type': 'application/vnd.api+json',
	}
};

const actions = {

	getDemands(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/demands/index', payload, options)
			.then((response) => {
				return response
			})
	},
	
	getDashboardDemands(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/demands/index_dashboard', payload, options)
			.then((response) => {
				return response
			})
	},

	getActionsAuth() {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/actions/fetch/auth')
			.then((response) => {
				return response
			})
	},

	fetchByProspect(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/demands/fetch/prospect', payload, options)
			.then((response) => {
				return response
			})
	},
	
	fetchLinkedDemands(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/demands/fetch/linked', payload, options)
			.then((response) => {
				return response
			})
	},

	fetchByClientOrSite(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/demands/fetch/client_site', payload, options)
			.then((response) => {
				return response
			})
	},

	getDemandDetails(context, payload) {
		return axios.get(process.env.VUE_APP_API_BASE_URL + '/demands/' + payload.demandId)
			.then((response) => {
				return response
			})
	},

	addDemand(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/demands', payload, options)
			.then((response) => {
				return response
			})
	},

	updateDemand(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL + '/demands/' + payload.demandId, payload, options)
			.then((response) => {
				return response
			})
	},

	updateDemandStatus(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL + '/demands/' + payload.demandId + '/status', payload, options)
			.then((response) => {
				return response
			})
	},

	sendMailToTechnicians(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL + '/demands/' + payload.demandId + '/email', payload, options)
			.then((response) => {
				return response
			})
	},

}

const getters = {
	list: state => state.list,
};

const demands = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

export default demands;
